import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'accounts'
const verb = 'get'

export default class OspreyAccountsSearchSuggestion extends BaseAction {
    constructor(dataKey) {
        const id = '60c2a0f7-bfba-41d4-9e65-cca31c93967b'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true
    }

    getSearchSuggestion(params) {
        this.params = Object.assign({
            fields: 'id,name',
            sf: 'name',
            sd: 'asc',
        }, params)

        return fetchContentIfNeeded(this)
    }
}



// WEBPACK FOOTER //
// src/actions/osprey-api/accounts/accounts-search-suggestion.js